routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    // .state('home.productDetail', {
    //   url: "/categories",
    //   template: `<product-detail sh-ctrl="shCtrl"></product-detail>`
    // })

    .state('home.productDetailSlug', {
      url: __env.routes.productDetailSlug,
      template: `<product-detail sh-ctrl="shCtrl"></product-detail>`
    })
    .state('home.productDetailId', {
      url: __env.routes.productDetailId,
      template: `<product-detail sh-ctrl="shCtrl"></product-detail>`
    });

}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/catalog/product-detail/product-detail.config.js